import env from 'env';
import axios from 'axios';
import Qs from 'qs';

const qsGateway = axios.create({
  baseURL: env.qsGatewayBaseUrl,
  responseType: 'json',
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  paramsSerializer(params) {
    return Qs.stringify(params, { arrayFormat: 'brackets' });
  },
});

let store;

export function setStore(s) {
  store = s;
  s.subscribe(listener);
}

function select(state) {
  return state.account.user && state.account.user.accessToken;
}

function listener() {
  const token = select(store.getState());

  qsGateway.defaults.headers.common.Authorization = `Bearer ${token}`;
}

export function getWebSocketURL() {
  const token = select(store.getState());

  return `${env.qsGatewayBaseUrl}ws/events?token=Bearer ${token}`;
}

export default qsGateway;
